import { OfficeVisitQueryFilter } from "@model/crm/office-visit";
import { useAppSelector } from '@crm/core';
import { useEffect } from "react";
import { useLocalStorage } from '@crm/libs/hooks';

export const useFilter = () => {
  const { loggedInUserId } = useAppSelector((store) => ({
    loggedInUserId: store.auth?.user?.id,
  }));
  const [filterQuery, setFilterQuery, removeFilterFromStorage] = useLocalStorage<OfficeVisitQueryFilter | null>("officeVisitFilter", "");

  // select user as initial assignee if filter is not present
  useEffect(() => {
    if (!filterQuery && loggedInUserId) {
      setFilterQuery({ filter: { assigneeId: [loggedInUserId] }, type: 'pending' });
    }
  }, [])

  return { filterQuery, setFilterQuery, removeFilterFromStorage };

}

